import React, { useState } from "react";
import { motion } from "framer-motion";
import { X, Copy, Sparkles, CheckCircle2, KeyRound } from "lucide-react";
import { toast } from "sonner";

export default function ActivateModal({ recruiter, setupUrl, onClose }) {
  const fullUrl = `${window.location.origin}${setupUrl}`;
  const copy = () => {
    navigator.clipboard.writeText(fullUrl);
    toast.success("Activation link copied");
  };
  return (
    <div
      className="fixed inset-0 z-50 bg-slate-900/50 backdrop-blur-sm flex items-start justify-center p-4 overflow-y-auto"
      onClick={onClose}
    >
      <motion.div
        initial={{ y: 20, opacity: 0, scale: 0.98 }}
        animate={{ y: 0, opacity: 1, scale: 1 }}
        transition={{ type: "spring", damping: 22 }}
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-lg my-8 bg-white rounded-2xl shadow-2xl overflow-hidden"
      >
        <div className="bg-gradient-to-r from-[#C49A3A] to-[#E0BB5C] px-5 py-4 text-white flex items-center justify-between">
          <div className="flex items-center gap-2">
            <KeyRound className="w-4 h-4" />
            <div className="text-sm font-semibold">Recruiter Activated</div>
          </div>
          <button
            onClick={onClose}
            className="text-white/80 hover:text-white"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        <div className="p-6 space-y-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl bg-emerald-50 flex items-center justify-center">
              <CheckCircle2 className="w-6 h-6 text-emerald-600" />
            </div>
            <div>
              <div className="font-display text-lg font-semibold text-slate-900">
                Welcome email ready
              </div>
              <div className="text-xs text-slate-500">
                {recruiter.full_name} · {recruiter.email}
              </div>
            </div>
          </div>
          <div className="bg-slate-50 border border-slate-200 rounded-lg p-3 space-y-2">
            <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold">
              Subject
            </div>
            <div className="text-sm text-slate-800 font-medium">
              Welcome to the Cambridge College Recruiter Portal
            </div>
            <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold pt-2">
              Message preview
            </div>
            <div className="text-[12px] text-slate-600 whitespace-pre-wrap">{`Hi ${recruiter.full_name},

Your Cambridge College recruiter account has been activated. Please set your password using the secure link below. Your user ID is your email address: ${recruiter.email}.

After setting your password you will be automatically signed in to the recruiter portal where you can submit referrals and track your applications.

— Cambridge College Admissions`}</div>
          </div>
          <div className="bg-slate-50 border border-slate-200 rounded-lg p-3">
            <div className="text-[11px] uppercase tracking-wider text-slate-500 font-semibold mb-1">
              Activation link (expires in 7 days)
            </div>
            <div className="flex items-center gap-2">
              <code className="flex-1 text-[12px] text-slate-700 bg-white border border-slate-200 rounded-md px-2 py-1.5 truncate">
                {fullUrl}
              </code>
              <button
                onClick={copy}
                className="inline-flex items-center gap-1 bg-cct-blue text-white text-xs font-semibold px-3 py-1.5 rounded-md hover:bg-[#1a3380]"
              >
                <Copy className="w-3.5 h-3.5" /> Copy
              </button>
            </div>
          </div>
          <div className="text-[12px] text-slate-500 bg-amber-50 border border-amber-100 rounded-lg px-3 py-2 flex items-start gap-2">
            <Sparkles className="w-3.5 h-3.5 text-amber-600 mt-0.5 shrink-0" />
            <span>
              In production, this link is automatically emailed to the
              recruiter. Copy & share it manually for now.
            </span>
          </div>
          <div className="flex justify-end pt-2">
            <button
              onClick={onClose}
              className="bg-cct-blue text-white text-sm font-semibold px-5 py-2 rounded-md hover:bg-[#1a3380]"
            >
              Done
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
